import 'hammerjs';
import { Provider } from '@angular/core';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material';
import { SCROLL_STRATEGY_PROVIDER_FACTORY } from './scroll-strategy';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../environments/environment';
import { StubInterceptor } from './stub-interceptor';
var ɵ0 = SCROLL_STRATEGY_PROVIDER_FACTORY;
var providers = [
    { provide: MAT_DIALOG_SCROLL_STRATEGY, useFactory: ɵ0 }
];
if (environment.useStubInterceptor) {
    providers.push({ provide: HTTP_INTERCEPTORS, useClass: StubInterceptor, multi: true });
}
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js